import { Record, List } from 'immutable';
import AuthCreds from 'automation-ui-canvas/data/records/AuthCreds';
import * as ActionTypes from 'automation-ui-canvas/constants/ActionTypes';
import * as TaskActionDefaults from 'automation-ui-canvas/constants/TaskActionDefaults';
import * as DirectiveTypes from 'automation-ui-canvas/constants/DirectiveTypes';
import * as InternalPropertyDefaults from 'automation-ui-canvas/constants/InternalPropertyDefaults';
import * as SendNotificationViaConstants from 'automation-ui-canvas/constants/SendNotificationViaConstants';
const SFDC_TASK_OWNER_EMAIL_VALUE = 'Owner Email';
const DEFAULT_ACTION = {
  actionId: null,
  name: null,
  stepId: null,
  type: ActionTypes.EMPTY,
  errors: List(),
  warnings: List(),
  info: List()
};
const EMAIL_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.EMAIL,
  emailCampaignId: null,
  emailCampaignGroupId: null,
  emailContentId: null,
  clickThroughRatio: null,
  goalListCount: null
});
const NOTIFICATION_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.NOTIFICATION,
  emailCampaignId: null,
  emailCampaignGroupId: null,
  emailContentId: null,
  recipientProperty: null,
  staticRecipient: null
});
const SMS_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.SMS_NOTIFICATION,
  body: '',
  staticTo: null,
  userId: null
});
const SEND_NOTIFICATION_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.SEND_NOTIFICATION,
  body: '',
  delivery: SendNotificationViaConstants.IN_APP,
  recipientUserIds: List(),
  recipientTeamIds: List()
  // To be supported in future version
  // recipient_owner_props: List(),
});
const DELAY_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.DELAY,
  anchorSetting: null,
  delayMillis: 0,
  stepListCount: null
});
const BRANCH_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.BRANCH,
  acceptActions: List(),
  rejectActions: List(),
  filters: List(),
  filtersListId: null
});
const SET_PROPERTY_ACTION = Object.assign({}, DEFAULT_ACTION, {
  newValue: null,
  propertyName: ''
});
const SET_CONTACT_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  type: ActionTypes.SET_CONTACT_PROPERTY
});
const SET_COMPANY_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  type: ActionTypes.SET_COMPANY_PROPERTY
});
const CLEAR_CONTACT_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  type: ActionTypes.CLEAR_CONTACT_PROPERTY
});
const CLEAR_COMPANY_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  type: ActionTypes.CLEAR_COMPANY_PROPERTY
});
const ADD_CONTACT_ENUM_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  isReplacement: null,
  type: ActionTypes.ADD_CONTACT_ENUM_PROPERTY
});
const ADD_COMPANY_ENUM_PROPERTY_ACTION = Object.assign({}, SET_PROPERTY_ACTION, {
  isReplacement: null,
  type: ActionTypes.ADD_COMPANY_ENUM_PROPERTY
});
const UPDATE_LIST_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.UPDATE_LIST,
  directive: DirectiveTypes.ADD,
  listId: null
});
const REMOVE_LIST_ACTION = Object.assign({}, UPDATE_LIST_ACTION, {
  type: ActionTypes.REMOVE_LIST,
  directive: DirectiveTypes.REMOVE
});
const ADD_SUBTRACT_PROPERTY_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.ADD_SUBTRACT_PROPERTY,
  propertyName: null,
  valueToModifyPropertyBy: 0
});
const INCREMENT_COMPANY_PROPERTY_ACTION = Object.assign({}, ADD_SUBTRACT_PROPERTY_ACTION, {
  type: ActionTypes.INCREMENT_COMPANY_PROPERTY
});
const COPY_PROPERTY_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.COPY_PROPERTY,
  sourceProperty: null,
  targetModel: 'CONTACT',
  targetProperty: null
});
const COPY_COMPANY_PROPERTY_ACTION = Object.assign({}, COPY_PROPERTY_ACTION, {
  type: ActionTypes.COPY_COMPANY_PROPERTY
});
const WEBHOOK_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.WEBHOOK,
  method: 'POST',
  url: '',
  appId: null,
  authCreds: new AuthCreds()
});
const WORKFLOW_ENROLLMENT_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.WORKFLOW_ENROLLMENT,
  workflowId: null
});
const SET_SALESFORCE_CAMPAIGN_MEMBERSHIP_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.SET_SALESFORCE_CAMPAIGN_MEMBERSHIP,
  campaignId: null,
  status: null
});
const CREATE_SFDC_TASK_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.CREATE_SFDC_TASK,
  comments: null,
  daysFrom: null,
  email: SFDC_TASK_OWNER_EMAIL_VALUE,
  priority: null,
  status: '',
  subject: ''
});
const TASK_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.TASK,
  assignCurrent: false,
  ownerProperty: InternalPropertyDefaults.HUBSPOT_OWNER,
  ownerId: null,
  description: '',
  dueDays: null,
  dueMinutes: null,
  dueImmediately: true,
  noReminderDate: true,
  reminderDays: null,
  reminderMinutes: null,
  subject: '',
  taskType: TaskActionDefaults.TASK_ACTION_TYPE
});
const HUBSPOT_OWNER_ID = Record({
  sourcePropertyType: 'CONTACT',
  sourcePropertyName: InternalPropertyDefaults.HUBSPOT_OWNER
});
const DEAL_ACTION_PROPERTIES_RECORD = Record({
  hubspot_owner_id: new HUBSPOT_OWNER_ID(),
  pipeline: '',
  dealname: '',
  closedate: '',
  dealstage: null,
  amount: ''
});
const DEAL_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.DEAL,
  properties: new DEAL_ACTION_PROPERTIES_RECORD()
});
const TICKET_ACTION_PROPERTIES_RECORD = Record({
  hubspot_owner_id: new HUBSPOT_OWNER_ID(),
  subject: '',
  hs_pipeline: '',
  hs_pipeline_stage: '',
  source_type: '',
  content: ''
});
const TICKET_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.TICKET,
  properties: new TICKET_ACTION_PROPERTIES_RECORD()
});
const LEAD_ASSIGNMENT_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.LEAD_ASSIGNMENT,
  ownerProperty: InternalPropertyDefaults.HUBSPOT_OWNER,
  owners: List(),
  teamId: null,
  overwriteCurrentOwner: false
});
const DATE_STAMP_PROPERTY_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.DATE_STAMP_PROPERTY,
  model: null,
  propertyName: null
});
const EXTENSION_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.EXTENSION,
  extensionDefinitionId: null,
  extensionId: null,
  extensionDefinitionVersion: null,
  metadata: {}
});
const UNSUPPORTED_ACTION = Object.assign({}, DEFAULT_ACTION, {
  type: ActionTypes.UNSUPPORTED_ACTION,
  actionId: null,
  contextJson: null,
  stepId: null
});
export const ActionTypeToRecord = {
  [ActionTypes.EMAIL]: Record(EMAIL_ACTION),
  [ActionTypes.NOTIFICATION]: Record(NOTIFICATION_ACTION),
  [ActionTypes.SMS_NOTIFICATION]: Record(SMS_ACTION),
  [ActionTypes.SEND_NOTIFICATION]: Record(SEND_NOTIFICATION_ACTION),
  [ActionTypes.DELAY]: Record(DELAY_ACTION),
  [ActionTypes.BRANCH]: Record(BRANCH_ACTION),
  [ActionTypes.SET_CONTACT_PROPERTY]: Record(SET_CONTACT_PROPERTY_ACTION),
  [ActionTypes.SET_COMPANY_PROPERTY]: Record(SET_COMPANY_PROPERTY_ACTION),
  [ActionTypes.UPDATE_LIST]: Record(UPDATE_LIST_ACTION),
  [ActionTypes.REMOVE_LIST]: Record(REMOVE_LIST_ACTION),
  [ActionTypes.ADD_SUBTRACT_PROPERTY]: Record(ADD_SUBTRACT_PROPERTY_ACTION),
  [ActionTypes.INCREMENT_COMPANY_PROPERTY]: Record(INCREMENT_COMPANY_PROPERTY_ACTION),
  [ActionTypes.COPY_PROPERTY]: Record(COPY_PROPERTY_ACTION),
  [ActionTypes.COPY_COMPANY_PROPERTY]: Record(COPY_COMPANY_PROPERTY_ACTION),
  [ActionTypes.EXTENSION]: Record(EXTENSION_ACTION),
  [ActionTypes.WEBHOOK]: Record(WEBHOOK_ACTION),
  [ActionTypes.CLEAR_CONTACT_PROPERTY]: Record(CLEAR_CONTACT_PROPERTY_ACTION),
  [ActionTypes.CLEAR_COMPANY_PROPERTY]: Record(CLEAR_COMPANY_PROPERTY_ACTION),
  [ActionTypes.WORKFLOW_ENROLLMENT]: Record(WORKFLOW_ENROLLMENT_ACTION),
  [ActionTypes.SET_SALESFORCE_CAMPAIGN_MEMBERSHIP]: Record(SET_SALESFORCE_CAMPAIGN_MEMBERSHIP_ACTION),
  [ActionTypes.CREATE_SFDC_TASK]: Record(CREATE_SFDC_TASK_ACTION),
  [ActionTypes.TASK]: Record(TASK_ACTION),
  [ActionTypes.DEAL]: Record(DEAL_ACTION),
  [ActionTypes.TICKET]: Record(TICKET_ACTION),
  [ActionTypes.LEAD_ASSIGNMENT]: Record(LEAD_ASSIGNMENT_ACTION),
  [ActionTypes.EMPTY]: Record(DEFAULT_ACTION),
  [ActionTypes.DATE_STAMP_PROPERTY]: Record(DATE_STAMP_PROPERTY_ACTION),
  [ActionTypes.ADD_CONTACT_ENUM_PROPERTY]: Record(ADD_CONTACT_ENUM_PROPERTY_ACTION),
  [ActionTypes.ADD_COMPANY_ENUM_PROPERTY]: Record(ADD_COMPANY_ENUM_PROPERTY_ACTION),
  [ActionTypes.UNSUPPORTED_ACTION]: Record(UNSUPPORTED_ACTION)
};